export const ObjectKeys = <T extends Record<string, any>>(object: T): Array<keyof T> =>
	Object.keys(object) as any;

export const ObjectEntries = <T extends string, K>(o: Record<T, K>): [T, K][] =>
	Object.entries(o) as any;

